module.exports = __webpack_public_path__ + "static/media/partners.3a4c61c2.png";